import { Checkbox, IconButton, Typography, Popover, Tooltip } from "@material-ui/core";
import React from "react";
import InfoIcon from '@mui/icons-material/Info';
import { FilterWrapper } from "./Filter.style";
// import TuneIcon from '@material-ui/icons/Tune';
import { connect } from "react-redux";
import { saveFilter } from "Components/Commons/Topbar/Filter/Actions"
import { withRouter } from "react-router";


import EDriveImg from 'Assets/Images/EDrive1.png'
import ThreeIn1Img from 'Assets/Images/ICT1.png'
//import ThreeIn1Img from 'Assets/Images/3-in-1 bin.png'
import BatteryOnlyImg from 'Assets/Images/Battery1.png'
//import BatteryOnlyImg from 'Assets/Images/Battery-only bin.png'
//import BbWithTubeImg from 'Assets/Images/BB bin with Fluorescent tub.png'
import BbWithTubeImg from 'Assets/Images/BatteryBulbTube1.png'
//import BbImg from 'Assets/Images/BB bin.png'
import BbImg from 'Assets/Images/Battery&Bulb1.png'
import DepotOnlyImg from 'Assets/Images/DepotDropOff1.png'
import MannedCollectionImg from 'Assets/Images/MannedCollection1.png'
// import FilterClose from "Assets/Images/filter_close.svg";

const Types = {
    ALL: "ALL",
    BIN: "BIN",
    RVM: "RVM",
    CFT: "CASH_FOR_TRASH",
    E_BIN: "E_BIN",
    E_BIN_THREE_IN_ONE_BIN: "E_BIN_THREE_IN_ONE_BIN",
    E_BIN_BB_BIN: "E_BIN_BB_BIN",
    E_BIN_BATTERY_BIN: "E_BIN_BATTERY_BIN",
    E_BIN_DEPOT_ONLY: "E_BIN_BATTERY_BULB_TUBE",
    SPECIAL_QR_CODE: "SPECIAL_QR_CODE",
    E_DRIVE: "E_BIN_E_DRIVE",
    DEPOT_DROP_OFF: "E_BIN_DEPOT_DROP_OFF",
    MANNED_COLLECTION: "E_BIN_MANNED_COLLECTION"
}

// const filterTypes = [
//     { id: 1, type: Types.ALL, label: "All" },
//     { id: 2, type: Types.BIN, label: "Recycling Bins" },
//     { id: 3, type: Types.RVM, label: "Reverse Vending Machine" },
//     { id: 4, type: Types.CFT, label: "Cash-for-Trash" },
//     { id: 5, type: Types.SPECIAL_QR_CODE, label: "Shoe Collection" },
// ]

const eBinFilters = [
    { id: 9, type: Types.E_DRIVE, label: "E-Drive", image: EDriveImg, desc: "Active on selected dates" },
    { id: 6, type: Types.E_BIN_THREE_IN_ONE_BIN, label: "ICT, Battery, Bulb", image: ThreeIn1Img },
    { id: 7, type: Types.E_BIN_BB_BIN, label: "Battery & Bulb", image: BbImg },
    { id: 8, type: Types.E_BIN_BATTERY_BIN, label: "Battery", image: BatteryOnlyImg },
    { id: 8, type: Types.E_BIN_DEPOT_ONLY, label: "Battery, Bulb & Tube", image: BbWithTubeImg },
    { id: 9, type: Types.DEPOT_DROP_OFF, label: "Depot Drop Off", image: DepotOnlyImg },
    { id: 10, type: Types.MANNED_COLLECTION, label: "Manned Collection", image: MannedCollectionImg, desc: "Please verify what can be dropped off at each location" }
]


class Filter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorElement: null,
            anchorRef: null,
            isOpen: false,
            markersList: [],
            filterType: Types.E_BIN,
            eBin: [],
            showPopUpModal: null,
            currentType: ""
        }
    }

    componentDidMount() {

        if (this.props.history.location.search) {
            let type = this.props.history.location.search.split("&");


            const data = {
                filterType: type[0].split("=")[1]
            }

            type.splice(0, 1);
            let ebins = [];
            if (data.filterType === Types.E_BIN) {
                type.forEach((item) => {
                    return ebins.push(item.split("=")[1])
                })
                data.eBinTypes = ebins
            }


            this.props.saveFilter(data);
            this.setState({
                eBin: ebins,
                filterType: data.filterType
            })
        }

        this.props.history.push({
            pathname: '/map/filter',
            search: this.props.history.location.search ? this.props.history.location.search : '?filter=' + this.state.filterType
        })
    }


    handleAnchor = (event) => {
        const filterType = this.props.filter.filterType
        this.setState({
            anchorElement: this.state.anchorElement ? null : event.currentTarget,
            filterType: filterType ? filterType : Types.E_BIN
        });
    }

    handleCloseAnchor = () => {
        this.setState({
            anchorElement: null,
        });
    }

    saveFilterClickHandler = () => {
        const data = {
            filterType: this.state.filterType
        }


        let filterUrl = this.state.filterType;


        if (this.state.filterType === Types.E_BIN) {
            data.eBinTypes = this.state.eBin

            this.state.eBin.forEach(item => filterUrl += `&filter=${item}`)
        }

        this.props.history.push({
            pathname: '/map/filter',
            search: '?filter=' + filterUrl
        })

        this.props.saveFilter(data)
        this.setState({
            anchorElement: null,
        })
    }

    handleCheckboxToggle = (event) => {
        let newE_bin = this.state.eBin;
        if (event.target.value !== Types.E_BIN)
            newE_bin = []
        this.setState({
            filterType: event.target.value,
            eBin: newE_bin
        })
    }

    handleChange = (label) => {
        let newE_Bin = this.state.eBin;

        if (newE_Bin.includes(label)) {
            let find = newE_Bin.findIndex((item) => {
                return item === label
            })
            newE_Bin.splice(find, 1)

        } else {
            newE_Bin.push(label)
            if (newE_Bin.includes(Types.E_BIN_BATTERY_BIN)) {
                if (!newE_Bin.includes(Types.E_BIN_THREE_IN_ONE_BIN)) {
                    newE_Bin.push(Types.E_BIN_THREE_IN_ONE_BIN)
                }
                if (!newE_Bin.includes(Types.E_BIN_BB_BIN)) {
                    newE_Bin.push(Types.E_BIN_BB_BIN)
                }
                if (!newE_Bin.includes(Types.E_BIN_DEPOT_ONLY)) {
                    newE_Bin.push(Types.E_BIN_DEPOT_ONLY)
                }
                if (!newE_Bin.includes(Types.DEPOT_DROP_OFF)) {
                    newE_Bin.push(Types.DEPOT_DROP_OFF)
                }
            }
            else if (newE_Bin.includes(Types.E_BIN_BB_BIN)) {
                if (!newE_Bin.includes(Types.E_BIN_THREE_IN_ONE_BIN)) {
                    newE_Bin.push(Types.E_BIN_THREE_IN_ONE_BIN)
                }
                if (!newE_Bin.includes(Types.E_BIN_DEPOT_ONLY)) {
                    newE_Bin.push(Types.E_BIN_DEPOT_ONLY)
                }
                if (!newE_Bin.includes(Types.DEPOT_DROP_OFF)) {
                    newE_Bin.push(Types.DEPOT_DROP_OFF)
                }
            }
            else {
                if (!newE_Bin.includes(label)) {
                    newE_Bin.push(label)
                }
                // if (!newE_Bin.includes(Types.DEPOT_DROP_OFF)) {
                //     newE_Bin.push(Types.DEPOT_DROP_OFF)
                // }
            }
        }

        this.setState({
            filterType: Types.E_BIN,
            eBin: newE_Bin
        })
    }

    // render() {
    //     const isOpen = Boolean(this.state.anchorElement);  //Boolean(this.state.anchorElement)
    //     const id = isOpen ? 'simple-popover' : undefined;
    //     return (
    //         <FilterWrapper>
    //             <IconButton aria-label="Filter" color="inherit" onClick={this.handleAnchor}>
    //                 <Badge color="secondary">
    //                     <img src={require(`Assets/Images/filter.png`)} alt="filter" loading="lazy" />
    //                 </Badge>
    //             </IconButton>
    //             <StyledPopover
    //                 className={"popover-class"}
    //                 id={id}
    //                 open={isOpen}
    //                 onClose={() => this.setState({
    //                     anchorElement: null,
    //                 })}
    //                 anchorEl={this.state.anchorElement}

    //                 anchorOrigin={{
    //                     vertical: 'bottom',
    //                     horizontal: 'center',
    //                 }}
    //                 transformOrigin={{
    //                     vertical: 'top',
    //                     horizontal: 'center',
    //                 }}
    //                 classes={{ paper: "popover-paper" }}
    //             >
    //                 <div className={"popover-content flex f-column"}>

    //                     <List component="nav" className="full-width filter-container" aria-label="mailbox folders">
    //                         <ListItem disableGutters>
    //                             <Box className="filter-header-container flex full-width filter-box-container">
    //                                 <div className="flex f-h-center f-v-center">
    //                                     <IconButton aria-label="Filter" color="inherit" className="filter-header-icon" disabled disableFocusRipple disableRipple>
    //                                         <TuneIcon />
    //                                     </IconButton>
    //                                     <Typography variant="h4" className="filter-header-text">Filter</Typography>
    //                                 </div>

    //                                 {/* <IconButton aria-label="Filter" color="inherit" onClick={this.handleCloseAnchor}>
    //                                     <img src={FilterClose} alt="close" width="25px" height="25px" loading="lazy" />
    //                                 </IconButton> */}
    //                             </Box>
    //                         </ListItem>

    //                         <Divider className="filter-divider" />
    //                         <ListItem >
    //                             <Box className="flex f-column full-width filter-box-container">
    //                                 <Typography variant="body1" className="filter-favourite-text">Select E-bin Type</Typography>
    //                                 {/* <RadioGroup className="markers-list-container" aria-label="filterType" name="filterType" value={this.state.filterType} onChange={this.handleCheckboxToggle}>
    //                                     {filterTypes.map((value) => {
    //                                         return (
    //                                             <FormControlLabel key={value.id} value={value.type} control={<Radio />} label={value.label} />
    //                                         )
    //                                     })}
    //                                 </RadioGroup> */}


    //                                 {eBinFilters.map((value) => {
    //                                     return (
    //                                         <div className="e-bin-markers-list-container" key={value.id}>
    //                                             <Checkbox
    //                                                 checked={this.state.eBin.includes(value.type) ? true : false}
    //                                                 onChange={() => this.handleChange(value.type)}
    //                                                 value={value.type}
    //                                                 name={value.id}
    //                                             />
    //                                             <div className='text'>{value.label}</div>
    //                                             <div className='image-icon'>
    //                                                 <img src={value.image} alt="logo" />
    //                                             </div>
    //                                         </div>
    //                                     )
    //                                 })}
    //                             </Box>
    //                         </ListItem>
    //                         <Divider className="filter-divider" />
    //                         <ListItem button onClick={this.saveFilterClickHandler}>
    //                             <Box className="text-center full-width filter-save-button">
    //                                 Save
    //                             </Box>

    //                         </ListItem>
    //                     </List>


    //                 </div>
    //             </StyledPopover>
    //         </FilterWrapper>
    //     )
    // }

    handleClick = (event, type) => {
        this.setState({
            showPopUpModal: event.currentTarget,
            currentType: type
        })
    };

    handleEBinMannedClick = (event, type) => {
        if (!this.state.eBin.includes(type)) return
        if ((type === Types.E_DRIVE || type === Types.MANNED_COLLECTION)) {
            this.setState({
                showPopUpModal: event.currentTarget,
                currentType: type
            })
        }
    };

    handleClose = (e) => {
        this.setState({
            showPopUpModal: null
        })
    };


    render() {
        const open = Boolean(this.state.showPopUpModal);
        const id = open ? 'simple-popover' : undefined;
        let THREE_IN_ONE_TEXT = "<p><strong>Information and Communication Equipment (ICT)</strong><br /> Printer, Computer, Laptop, Tablet, Desktop Monitor, Router, Modem, Set-Top Box, Network Switch, Network Hub, Mobile Telephone<br /> <em>ICT equipment can be disposed of together with their embedded batteries as well as any cables, adaptors, remote controls, keyboards used with the product.&nbsp;</em></p>"
        return (
            <FilterWrapper>
                <Typography className="heading">{"Select your bin based on your E-Waste type"}</Typography>
                <div className="filter-container">
                    {eBinFilters.map((value, index) => {
                        return (
                            <div className="e-bin-markers-list-container" key={value.id}>
                                <Checkbox
                                    checked={this.state.eBin.includes(value.type) ? true : false}
                                    onChange={(e) => {
                                        this.handleChange(value.type);
                                        this.saveFilterClickHandler();
                                        this.handleEBinMannedClick(e, value.type)
                                    }}
                                    value={value.type}
                                    name={value.id}
                                    className="checkbox"
                                />
                                <div className='image-icon'>
                                    <img src={value.image} alt="logo" className={`${index % 2 === 0 ? `odd-image` : 'even-image'}`} />
                                </div>
                                <div className='text'>{value.label}</div>

                                {
                                    (value.type === Types.E_DRIVE || value.type === Types.MANNED_COLLECTION || value.type === Types.E_BIN_THREE_IN_ONE_BIN) && (
                                        <>
                                            <Tooltip title="Info">
                                                <IconButton
                                                    aria-describedby={id}
                                                    className="info-icon"
                                                    onClick={(e) => this.handleClick(e, value.type)}
                                                    sx={{ padding: "0px" }}
                                                >
                                                    <InfoIcon sx={{ color: "#FECD70", height: "18px" }} />
                                                </IconButton>
                                            </Tooltip>

                                            <Popover
                                                id={id}
                                                open={open}
                                                anchorEl={this.state.showPopUpModal}
                                                onClose={this.handleClose}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                style={{
                                                    boxShadow: "5px 10px"
                                                }}
                                            >
                                                <Typography style={{ padding: "1rem" }}>
                                                    {this.state.currentType === Types.E_DRIVE && "Active on selected dates"}
                                                    {this.state.currentType === Types.MANNED_COLLECTION && "Please verify what can be dropped off at each location"}
                                                    {this.state.currentType === Types.E_BIN_THREE_IN_ONE_BIN &&
                                                        <div
                                                            dangerouslySetInnerHTML={{ __html: THREE_IN_ONE_TEXT }}
                                                        />
                                                    }
                                                </Typography>
                                            </Popover>
                                        </>
                                    )
                                }
                            </div>
                        )
                    })}
                </div>
            </FilterWrapper>
        )
    }
}


const mapReduxStateToProps = (state) => ({
    filter: state.Filter.filter
})
const mapDispatchStateToProps = dispatch => ({
    saveFilter: (payload) => dispatch(saveFilter(payload))
});

export default connect(mapReduxStateToProps, mapDispatchStateToProps)(withRouter(Filter));